var _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _circle2, _polygon5, _polygon6, _rect, _rect2, _polygon7, _path12, _rect3, _path13, _circle3, _path14, _path15, _path16, _rect4, _path17, _path18, _path19, _path20, _rect5, _rect6, _rect7, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _rect8, _rect9, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndrawBikingKc4F(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 937.59653,
    height: 653.44451,
    viewBox: "0 0 937.59653 653.44451",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "biking") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "195.992 26.994 200.088 364.913 377.078 451.126 372.982 113.208 195.992 26.994",
    fill: "#f2f2f2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "142.208 0 9.957 271.502 189.403 358.913 185.307 20.994 142.208 0",
    fill: "#f2f2f2"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "937.597 381.414 580.403 207.422 584.499 545.34 805.345 652.916 937.597 381.414",
    fill: "#f2f2f2"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "388.982 113.208 393.078 451.126 570.069 537.34 565.973 199.422 388.982 113.208",
    fill: "#f2f2f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M581.70174,506.22225l-5,112s13,106,10,109-11,9-5,16,28,12,29,8,3-118,3-118l7-135Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M581.70174,506.22225l-5,112s13,106,10,109-11,9-5,16,28,12,29,8,3-118,3-118l7-135Z",
    transform: "translate(-131.20174 -123.27775)",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M586.70174,741.22225s-25,19-28,19-30,9-11,13,65,2,66-4-3-24.20866-3-24.20866Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M586.70174,741.22225s-25,19-28,19-30,9-11,13,65,2,66-4-3-24.20866-3-24.20866Z",
    transform: "translate(-131.20174 -123.27775)",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M524.70174,422.22225s-11,4-11,7-10,41-12,43-3,11-3,11-10,23-8,23,19-4,20,0,9-25,9-25l17-34Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#6c63ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M490.70174,510.22225s3,22,11,24,0-28,0-28Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M516.70174,410.22225s6,13,9,20,31-18,31-18-15-11-15-16S516.70174,410.22225,516.70174,410.22225Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M228.2409,735.27771c6.70634,24.79066,29.67708,40.14415,29.67708,40.14415s12.0976-24.84013,5.39126-49.6308-29.67707-40.14414-29.67707-40.14414S221.53456,710.487,228.2409,735.27771Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M238.0954,729.94993c18.40229,17.91389,20.65,45.45172,20.65,45.45172s-27.58831-1.50634-45.99061-19.42023-20.65-45.45172-20.65-45.45172S219.6931,712.036,238.0954,729.94993Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#6c63ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M466.70174,776.22225a91,91,0,1,1,91-91A91.10284,91.10284,0,0,1,466.70174,776.22225Zm0-180a89,89,0,1,0,89,89A89.10056,89.10056,0,0,0,466.70174,596.22225Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M746.70174,776.22225a91,91,0,1,1,91-91A91.10284,91.10284,0,0,1,746.70174,776.22225Zm0-180a89,89,0,1,0,89,89A89.10025,89.10025,0,0,0,746.70174,596.22225Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 335.5,
    cy: 561.94451,
    r: 6,
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 617.5,
    cy: 561.94451,
    r: 6,
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "344.42 553.337 342.58 552.552 394.845 429.931 543.055 432.955 543.342 433.405 616.342 547.405 614.658 548.484 541.945 434.934 396.155 431.958 344.42 553.337",
    fill: "#2f2e41"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "500.125 576.128 538.538 440.672 540.462 441.217 502.875 573.761 603.374 560.952 603.626 562.937 500.125 576.128",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 572.2018,
    y: 563.17975,
    width: 1.99988,
    height: 147.08501,
    transform: "translate(-413.07405 460.30478) rotate(-44.4491)",
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 666.29998,
    y: 542.22229,
    width: 22.80351,
    height: 1.99993,
    transform: "translate(-155.67744 931.13616) rotate(-74.76942)",
    fill: "#2f2e41"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "398.476 424.166 396.524 423.723 401.247 402.945 384.5 402.945 384.5 389.945 386.5 389.945 386.5 400.945 403.753 400.945 398.476 424.166",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M643.70174,512.22225s0-6,13-3,53,11,56,10,2,6-11,9-28-4-31-6S643.70174,512.22225,643.70174,512.22225Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 450.5,
    y: 567.94451,
    width: 26,
    height: 10,
    fill: "#6c63ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M632.70174,718.22225a20,20,0,1,1,20-20A20.02229,20.02229,0,0,1,632.70174,718.22225Zm0-38a18,18,0,1,0,18,18A18.02094,18.02094,0,0,0,632.70174,680.22225Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.5,
    cy: 272.94451,
    r: 24,
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M601.70174,508.22225s-69,40-68,53,53,84,53,84,4,21,8,21,29,9,30,3-8-13-7-17-44-77-44-77,96.30708-36,76.15354-67S601.70174,508.22225,601.70174,508.22225Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M603.70174,662.22225s-12,3-14,7-37,17-27,20,68,4,70,2,0-25.2126-8-25.1063S607.70174,669.22225,603.70174,662.22225Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M525.70174,433.22225l22.5-27.5s25.5-7.5,36.5,7.5,41,52,51,60,24,39,19,40-33-11-44-3-32,9-33,5-61-71-61-80,6.39359-10.93113,6.39359-10.93113Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#6c63ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 502.70174,
    y: 507.22225,
    width: 38,
    height: 6,
    rx: 3,
    transform: "translate(68.70297 -267.99528) rotate(19.4707)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M469.70174,500.22225s-35,10-32,21,35-13,35-13Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#ffb8b8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M560.70174,413.22225s-14,12-17,26-18,39-18,39l-61,20s-4,19,2,19,73-14,75-17,45-60,45-60S590.70174,409.22225,560.70174,413.22225Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#6c63ff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M510.79531,368.44381a4.73339,4.73339,0,0,1-2.06116,1.03435,1.47087,1.47087,0,0,1-1.70452-1.1807,6.11136,6.11136,0,0,1-2.33876,2.99963c-1.1451.59683-2.91578.09638-3.08083-1.18434a5.40475,5.40475,0,0,1-1.244,2.62583,1.8631,1.8631,0,0,1-2.61916.08755c.50148,2.74053.192,5.55888.34944,8.34046s.89921,5.73046,3.00075,7.55954c3.06485,2.66751,7.67364,2.00916,11.7052,1.50379a3.55294,3.55294,0,0,1,1.83433.10034c1.50955.64313,1.44107,2.7445,1.46142,4.38521a12.18456,12.18456,0,0,0,10.66923,11.57068,6.10787,6.10787,0,0,0,4.53952-1.1079c1.14466-.97023,1.72935-2.55159,3.041-3.28043,2.13359-1.18558,4.72122.54346,6.28115,2.4208s3.09735,4.18665,5.5139,4.53031c3.196.4545,5.63028-2.80262,6.82457-5.80177a33.82171,33.82171,0,0,0-.67217-26.2798C545.62186,362.22039,522.82536,359.91951,510.79531,368.44381Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M933.09041,776.18124l-1.77735-.918c23.082-44.624,10.73926-102.5752-3.67871-143.332a439.29051,439.29051,0,0,0-37.27783-78.67481l1.69043-1.06836a441.53687,441.53687,0,0,1,37.47217,79.0752C944.0699,672.39315,956.49959,730.92245,933.09041,776.18124Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#2f2e41"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 908.61157,
    y: 587.22257,
    width: 72.18033,
    height: 1.99936,
    transform: "matrix(0.17975, -0.98371, 0.98371, 0.17975, 65.05255, 1288.53009)",
    fill: "#2f2e41"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 895.70138,
    y: 600.54655,
    width: 2.00072,
    height: 98.35141,
    transform: "translate(-333.5586 661.65986) rotate(-42.93968)",
    fill: "#2f2e41"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 939.19743,
    y: 715.2221,
    width: 58.00862,
    height: 2.00031,
    transform: "translate(-310.66012 957.99953) rotate(-54.13715)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 825,
    cy: 400.44451,
    r: 10,
    fill: "#6c63ff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 716,
    cy: 477.44451,
    r: 10,
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 760,
    cy: 487.44451,
    r: 10,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 740,
    cy: 526.44451,
    r: 10,
    fill: "#6c63ff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 865,
    cy: 551.44451,
    r: 10,
    fill: "#3f3d56"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 562.44451,
    r: 10,
    fill: "#3f3d56"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 855,
    cy: 594.44451,
    r: 10,
    fill: "#3f3d56"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 412.44451,
    r: 10,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 651.44451,
    width: 903,
    height: 2,
    fill: "#2f2e41"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 170.20174,
    y: 536.5846,
    width: 98,
    height: 98,
    transform: "translate(190.95803 -154.42515) rotate(30)",
    fill: "#f2f2f2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M239.20174,669.5846a22,22,0,1,1,22-22A22.02489,22.02489,0,0,1,239.20174,669.5846Zm0-42a20,20,0,1,0,20,20A20.02229,20.02229,0,0,0,239.20174,627.5846Z",
    transform: "translate(-131.20174 -123.27775)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawBikingKc4F);
export default __webpack_public_path__ + "static/media/undraw_biking_kc-4-f.1fcc4b16a285b66080b118bfeca951f5.svg";
export { ForwardRef as ReactComponent };